/**
 * `inputProps` for fields that must be typed by hand (e.g. Confirm password):
 * blocks paste, copy, cut and drag-and-drop into the input.
 */
const block = (e) => e.preventDefault();

export const noClipboardInputProps = {
  onPaste: block,
  onCopy: block,
  onCut: block,
  onDrop: block,
};
